import { AnyObj } from '../interfaces';
import { environment } from '../../environments/environment';
import { config } from '../../config';
import { base64Utility } from '../utils/base64Utility';

export const getSpecificKeyFromObject = (data: AnyObj, keys: String[]) => {
  const filteredData = {};
  for (const key in data) {
    if (keys.includes(key)) Object.assign(filteredData, { [key]: data[key] });
  }
  return filteredData;
};

export const deepCloneArray = <T>(inObject: any): Array<any> | AnyObj | T => {
  let outObject: any, value, key;

  if (typeof inObject !== 'object' || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCloneArray(value);
  }

  return outObject;
};

export const codeExtensionPhoneFormat = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{4})(\d{3})(\d{4})(\d{1,5})$/);
  return match
    ? '+' + match[1] + '-' + match[2] + '-' + match[3] + 'p' + match[4]
    : null;
};

export const countryCodePhoneFormat = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{4})(\d{3})(\d{4})$/);
  return match ? '+' + match[1] + '-' + match[2] + '-' + match[3] : null;
};

export const normalPhoneFormat = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? match[1] + '-' + match[2] + '-' + match[3] : null;
};

export const isJsonParsable = (json: any) => {
  try {
    const parsedJson = JSON.parse(json);
    return { success: true, parsedJson };
  } catch (error) {
    return { success: false };
  }
};

export const getFullName = (
  firstName: string,
  middleName: string,
  lastName: string,
) => {
  return [
    firstName ? firstName : '',
    middleName ? middleName : '',
    lastName ? lastName : '',
  ].join(' ');
};

/** Prefer first/middle/last over a stale banner `name` field. */
export const getVeteranDisplayName = (veteran?: {
  name?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
} | null): string => {
  if (!veteran) {
    return '';
  }
  const fromParts = [veteran.firstName, veteran.middleName, veteran.lastName]
    .filter((part) => part)
    .join(' ')
    .trim();
  return fromParts || veteran.name || '';
};

export const getCollegeAdminUrl = (collegeId: number) => {
  const serverUrl =
    config.serverUrl[environment.env as keyof typeof config.serverUrl];
  const encrypt = new base64Utility();
  return `${serverUrl}/login?cadmin=${encrypt.encodeBase64(
    `cid:${collegeId}`,
  )}`;
};

export const sort = (
  arr: any[],
  sortKey: string,
  sortOrder: 'asc' | 'desc',
) => {
  return arr.sort((a, b) => {
    return sortOrder === 'asc'
      ? a[sortKey] - b[sortKey]
      : b[sortKey] - a[sortKey];
  });
};

export const formatDate = (date: string) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
};

export function convertMonthDate(date: string) {
  if (!date.includes('-') && !date.includes('/')) return;
  if (date.includes('-')) {
    const [year, month] = date.split('-');
    return [month, year].join('/');
  } else if (date.includes('/')) {
    const [month, year] = date.split('/');
    return [year, month].join('-');
  }
  return;
}

export function displayVeteranMilitaryBase(militaryStatus: string) {
  let activeData = ['Active', 'Spouse', 'Dependent'];
  if (activeData.includes(militaryStatus)) {
    return true;
  } else {
    return false;
  }
}
